module.exports = __webpack_public_path__ + "static/media/assort.ef6cda3c.png";